<template>
  <div class="data-grid-image-upload">
    <el-upload ref="dataGridImageUpload"
               :class="{'exceed-upload-state': uploading || uploadImage.link}"
               drag
               :limit="1"
               :before-upload="beforeImageUpload"
               :on-success="handleImageUploadSuccess"
               :on-error="handleImageUploadError"
               :on-preview="handleFileUploadPreview"
               :on-remove="handleImageUploadRemove"
               list-type="picture"
               name="uploadFile"
               :http-request="httpRequest"
               :action="uploadAction"
               :data="uploadParams"
               :accept="uploadAccept"
               :file-list="imageList">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将图片拖到此处，或 <em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">
        <span v-if="imageSuffix && imageSuffix.length">
          只能上传{{imageSuffix.join('、')}}类型文件，且不能超过{{maxFileSize | formatFileSize}}
        </span>
        <span v-else>
          文件大小不能超过{{maxFileSize | formatFileSize}}
        </span>
      </div>
    </el-upload>
    <el-dialog :title="previewDialog.title + ' - 预览'"
               custom-class="data-grid-image-preview-dialog"
               :append-to-body="true"
               :visible.sync="previewDialog.isVisible">
      <img :src="previewDialog.imageUrl" alt="">
      <span slot="footer">
        <el-button type="primary" size="mini" @click="previewDialog.isVisible = false">关闭窗口</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Support from '../../../mixins/support'
import Emitter from 'element-ui/lib/mixins/emitter'
import ElUpload from '../../../mixins/upload/ElUpload'
import baseApiUrl from '../../../constants/baseApiUrl'
export default {
  mixins: [Support, Emitter, ElUpload],
  name: 'DataGridImageUpload',
  props: {
    value: {
      required: true
    },
    filename: {
      type: String
    },
    acceptType: {
      type: Object
    },
    maxFileSize: {
      type: Number,
      default: 20 * 1024 * 1024
    },
    column: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      defaultAcceptType: ['.jpg', '.jpeg', '.png', '.gif', '.bmp'],
      uploading: false,
      imageList: [],
      uploadImage: {
        name: '',
        link: null
      },
      previewDialog: {
        isVisible: false,
        title: '',
        imageUrl: ''
      }
    }
  },
  computed: {
    uploadAction: function () {
      return this.$contextPath(baseApiUrl.DataGridUrl)
    },
    uploadParams: function () {
      return this.$extend({
        requestType: 'upload',
        prop: this.column.prop
      }, this.$attrs)
    },
    uploadAccept: function () {
      if (this.imageSuffix && this.imageSuffix.length) {
        return this.imageSuffix.join(',')
      }
    },
    imageSuffix: function () {
      let suffix
      if (this.acceptType && this.acceptType.validators) {
        this.acceptType.validators.some((validator) => {
          if (validator.type === 'suffix') {
            let validate = validator.validate
            suffix = validate.suffix
            if (suffix && suffix.length > 0) {
              return suffix
            }
          }
        })
      }
      if (!suffix || suffix.length === 0) {
        suffix = this.defaultAcceptType
      }
      return suffix
    }
  },
  methods: {
    beforeImageUpload (file) {
      if (this.imageSuffix && this.imageSuffix.length > 0) {
        let filename = file.name
        let index = filename.lastIndexOf('.')
        if (index > 0) {
          let suffix = filename.substring(index).toLowerCase()
          if (!this.imageSuffix.includes(suffix)) {
            this.$message.error('上传的图片格式不合法')
            return false
          }
        } else {
          this.$message.error('上传的图片格式不合法')
          return false
        }
      }
      if (file.size <= this.maxFileSize) {
        this.uploading = true
        return true
      } else {
        this.$message.error('上传的图片大小超过限制')
        return false
      }
    },
    handleImageUploadSuccess (res) {
      this.uploading = false
      if (res['responseCode'] === 'SUCCESS') {
        this.uploadImage.name = res['imageName']
        this.uploadImage.link = res['imageUrl']
        this.$emit('input', this.uploadImage.link)
        this.$emit('change', this.uploadImage.link)
        this.$emit('update:filename', this.uploadImage.name)
        this.dispatch('ElFormItem', 'el.form.change', this.uploadImage.link)
      } else {
        this.$message.error(res.message || '获取返回信息失败')
      }
    },
    handleImageUploadError () {
      this.uploading = false
      this.clearUploadImage()
      this.$message.error('图片上传失败')
    },
    handleFileUploadPreview () {
      if (this.uploadImage.link) {
        this.previewDialog.title = this.uploadImage.name || '上传图片'
        this.previewDialog.imageUrl = this.$contextPath(this.uploadImage.link)
        this.previewDialog.isVisible = true
      }
    },
    handleImageUploadRemove () {
      this.clearUploadImage()
    },
    clearUploadImage () {
      this.uploadImage.name = null
      this.uploadImage.link = null
      this.$emit('input', '')
      this.$emit('change', '')
      this.$emit('update:filename', '')
      this.dispatch('ElFormItem', 'el.form.change', '')
    }
  },
  watch: {
    value: function (newValue) {
      if (newValue) {
        this.uploadImage.name = this.filename
        this.uploadImage.link = newValue
        this.imageList = [{
          name: this.uploadImage.name || `${this.column.name}（图片）`,
          url: this.$contextPath(newValue)
        }]
        this.$emit('update:filename', this.uploadImage.name)
      } else {
        this.clearUploadImage()
        let dataGridImageUpload = this.$refs['dataGridImageUpload']
        if (dataGridImageUpload) {
          dataGridImageUpload.clearFiles()
        }
      }
    },
    filename: function (newValue) {
      if (!newValue) {
        this.clearUploadImage()
      }
    }
  }
}
</script>

<style lang="scss">
  .el-form-item {
    &.is-success {
      .data-grid-image-upload {
        .el-upload {
          .el-upload-dragger {
            border-color: #67c23a;
          }
        }
      }
    }
    &.is-error {
      .data-grid-image-upload {
        .el-upload {
          .el-upload-dragger {
            border-color: #f56c6c;
          }
        }
      }
    }
    .data-grid-image-upload {
      * {
        transition: none!important;
      }
      .exceed-upload-state {
        .el-upload {
          display: none;
        }
        .el-upload__tip {
          display: none;
        }
        .el-upload-list {
          &.el-upload-list--picture {
            .el-upload-list__item {
              border-radius: 4px;
              border-color: #dcdfe6;
              &:first-child {
                margin-top: 0;
              }
              .el-upload-list__item-name {
                font-size: 12px;
              }
            }
          }
        }
      }
      .el-upload {
        width: 100%;
        .el-upload-dragger {
          width: 100%;
          height: 80px;
          border-style: solid;
          border-radius: 4px;
          .el-icon-upload {
            margin-top: 12px;
            margin-bottom: 0;
            font-size: 30px;
            line-height: 30px;
          }
          .el-upload__text {
            font-size: 12px;
            line-height: 1;
          }
        }
      }
      .el-upload__tip {
        margin-top: -5px;
        color: #909399;
        line-height: 24px;
      }
    }
  }

  .el-dialog__wrapper {
    & > .el-dialog {
      &.data-grid-image-preview-dialog {
        width: 720px;
        & > .el-dialog__body {
          img {
            display: block;
            margin: auto;
            max-width: 100%;
            max-height: 420px;
          }
        }
        & > .el-dialog__footer {
          text-align: center;
        }
      }
    }
  }
</style>
